var CurrentUser = require("lib/account/CurrentUser");

var NameLookup = {

	translateMap: function(otherMap, callback) {
		var runTranslate = function() {

			var studentHash = {};

			this[NameLookup.STUDENT_ARRAY_KEY].map(function(s) {
				var key = _.findKey(otherMap, _.partial(_.isEqual, s.id));
				if (key) {
					studentHash[key] = s.display_name;
				}
			}.bind(this));

			if (callback) { callback(studentHash); }
		}.bind(this)

		if (!this.isLoaded()) {
			this.loadStudentNames(runTranslate);
		} else {
			setTimeout(runTranslate, 5);
		}
	},

	getName: function(studentID, callback) {
		var studentData = this[NameLookup.STUDENT_ARRAY_KEY].find(function(student) {
			return student.id == studentID;
		});

		if (studentData) {
			return studentData.display_name;
		}
	},

	getNames: function(mirrorIDs) {
		return _.map(mirrorIDs, function(userID) {
			return this.getName(userID);
		}.bind(this));
	},

	isLoaded: function() {
		return this[NameLookup.STUDENT_ARRAY_KEY] != undefined;
	},

	loadStudentNames: function(callback) {

		if (CurrentUser.isStudent()) {
			var studentListID = CurrentUser.get().primary_student_list.id;
			CurrentUser.api().getStudentList(studentListID, { embed: "student_list.students" }, $wr.apiHandler(function(rsp) {
				var students = rsp.student_list.students;
				this[NameLookup.STUDENT_ARRAY_KEY] = students;
				if (callback) { callback(); }
			}.bind(this)));

		} else {
			CurrentUser.api().getStudentLists({ embed: "student_list.students" }, $wr.apiHandler(function(rsp) {
				var students = _.flatten(_.pluck(rsp.student_lists, "students"));
				this[NameLookup.STUDENT_ARRAY_KEY] = students;
				if (callback) { callback(); }
			}.bind(this)));
		}
	}
}

NameLookup.STUDENT_ARRAY_KEY = "__student_array_key__"

module.exports = NameLookup;



// WEBPACK FOOTER //
// ./modules/lib/data/NameLookup.js